<template>
  <div id="register" @click="area = false">
    <header>
      <div class="content">
        <span>欢迎使用中资云企业综合服务平台</span>
      </div>
    </header>
    <!-- 注册 -->
    <div class="content reg" v-show="regContent && member">
      <div class="titleBox flex-between">
        <div class="left">
          <a href="./login.html">
            <img src="../assets/imgs/register/titleLogo.png" alt />
          </a>
          <span>用户注册</span>
        </div>
        <div class="right">
          <p>
            我已注册,
            <router-link to="/login">立即登录</router-link>
          </p>
        </div>
      </div>
      <div class="progress flex-between">
        <div class="item" :class="step==1?'active':''" @click="goStep(1)">
          <div class="step" v-show="returnStatus1 == false">1</div>
          <div class="stepFinish" v-show="step != 1 && returnStatus1 == true">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>填写企业信息</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step==2?'active':''">
          <div class="step" v-show="returnStatus2 == false">2</div>
          <div class="stepFinish" v-show="step != 2 && returnStatus2 == true">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>注册账号</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step==3?'active':''">
          <div class="step" v-show="returnStatus3 == false">3</div>
          <div class="stepFinish" v-show="step != 3 && returnStatus3 == true">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>注册成功</span>
        </div>
      </div>
      <div class="registerBox">
        <div class="firstStep" v-show="step==1">
          <div class="title">
            <p>欢迎您使用中资云企业综合服务平台</p>
            <p>新用户注册</p>
          </div>
          <div class="inputBox">
            <div class="line">
              <p>企业名称</p>
              <input :class="inputIndex==1?'active':''" type="text" placeholder="请输入与营业执照上一致的企业名称" @focus="inputChange(1)" @blur="inputIndex=0" v-model="qiyeName" />
            </div>
            <div class="line">
              <p>统一社会信用代码</p>
              <input :class="inputIndex==2?'active':''" type="text" placeholder="请输入企业统一社会信用代码" @focus="inputChange(2)" @blur="inputIndex=0" v-model="blNum" />
            </div>
            <div class="line relative">
              <p>所属地区</p>
              <div class="input" style="position: relative;">
                <div style="position: absolute;top: 0;left: 0;width: 368px;height: 64px;" @click.stop="select"></div>
                <input id="input3" disabled :class="inputIndex==3?'active':''" type="text" placeholder="…请选择所属地区…" @blur="inputBlur" />
                <img src="../assets/imgs/register/down.png" alt class="down" />
                <ul class="selectBox" v-show="area" style="position: absolute;top: 56px;right: 0;cursor: pointer;">
                  <li v-for="(item,i) in citylist" :key="i" @click.stop="selectCity(item.ORG_ID,item.ORG_NAME)">
                    {{item.ORG_NAME}}</li>
                </ul>
              </div>
            </div>
            <button class="next nextGo" @click.stop="tijiao">下一步</button>
          </div>
        </div>
        <div class="secondStep" v-show="step==2">
          <div class="title">新用户注册</div>
          <div class="inputBox">
            <div class="line">
              <p>手机号</p>
              <input type="text" placeholder="请输入手机号" :class="inputIndex==1?'active':''" @focus="inputChange(1)" @blur="inputIndex=0" v-model="phone" />
            </div>
            <div class="code">
              <div class="line">
                <p>短信验证码</p>
                <div class="flex-between-center">
                  <input type="text" v-model="code" placeholder="请输入短信验证码" :class="inputIndex==2?'active':''" @focus="inputChange(2)" @blur="inputIndex=0" />
                  <div class="send" @click.stop="getCode">{{time}}{{cName}}</div>
                </div>
              </div>
            </div>
            <div class="line">
              <p>设置密码</p>
              <input type="password" placeholder="请输入密码" :class="inputIndex==3?'active':''" @focus="inputChange(3)" @blur="inputIndex=0" v-model="password" />
              <div class="strength flex-around-center">
                <div class="item">弱</div>
                <div class="item">中</div>
                <div class="item">强</div>
              </div>
            </div>
            <div class="line">
              <p>确认密码</p>
              <div class="input">
                <input type="password" placeholder="请再次输入密码" :class="inputIndex==4?'active':''" @focus="inputChange(4)" @blur="inputIndex=0" v-model="rpassword" />
                <div v-if="differentPass" class="different">两次密码输入不一致</div>
              </div>
            </div>
            <div class="butBox">
              <Button class="backBut" @click="goStep(1)">上一步</Button>
              <button class="next nextReginster" @click.stop="registerBtn">注册</button>
            </div>
          </div>
          <div class="bottom">
            <Checkbox label="twitter" v-model="isAgreement">
              <span>注册代表你已同意</span>
            </Checkbox>
            <span class="showAgree" @click.stop="regContent=false">《中资云用户注册协议》</span>
            <span class="showAgree" @click.stop="member=false">《会员服务协议》</span>
          </div>
        </div>
        <div class="thirdStep" v-show="step==3">
          <div class="title">注册成功</div>
          <div class="thirdContent">
            <img src="../assets/imgs/register/success.png" alt />
            <div class="successMsg">
              <p>
                <span>您已经注册成功，点击</span>
                <a @click="goLogin">立即登录</a>
              </p>
              <p>即可登录中资云企业综合服务平台</p>
            </div>
          </div>
          <div class="bottom">
            <span id="time">{{timeTimeout}}</span>
            <span>秒后系统自动跳转</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 协议 -->
    <div class="content agreement" v-show="regContent==false">
      <div class="back" @click.stop="regContent=true">
        <img src="../assets/imgs/register/back.png" alt />
        <span>返回</span>
      </div>
      <div class="agree">
        <div class="argeeTit">中资云用户注册协议</div>
        <protocol></protocol>
      </div>
    </div>
    <!-- 会员服务协议 -->
    <div class="content agreement" v-show="member==false">
      <div class="back" @click.stop="member=true">
        <img src="../assets/imgs/register/back.png" alt />
        <span>返回</span>
      </div>
      <div class="agree">
        <div class="argeeTit">会员服务协议</div>
        <memberAgreement></memberAgreement>
      </div>
    </div>
    <footer>
      <div class="top">
        <div class="content">
          <p>欢迎您使用中资云企业综合服务平台</p>
          <p>
            <span>技术支持</span>
            <img src="../assets/imgs/register/bottomLogo.png" alt class="bottomLogo" />
          </p>
        </div>
      </div>
      <div class="bottom">
        <span>Copyright@2015-2020 河南省非煤矿山管理办公室&中资互联网科技有限公司 All right Reserveds</span>
      </div>
    </footer>
    <!-- 已注册弹出框 -->
    <div class="alertMask" v-show="register">
      <div class="alert" v-if="companyInfo">
        <div class="alertBox">
          <div class="alertTitle">
            <span>提示</span>
            <img src="../assets/imgs/login/close.png" alt @click.stop="register=false" style="cursor: pointer;" />
          </div>
          <div class="alertContent">
            <div class="title">该企业已注册中资云账号，请直接登录！</div>
            <div class="middle">
              <p>如忘记账号或密码，可致电或前往所属市县交易中心找回。</p>
              <div class="bg">
                <p class="bgTitle" v-if="orgName">{{orgName}}</p>
                <div class="msgBox">
                  <div class="msgItem">
                    <img src="../assets/imgs/register/phone.png" alt />
                    <span class="msgTit">联系电话</span>
                    <span class="msgCon">{{companyInfo.mobileNo}}</span>
                  </div>
                  <div class="msgItem">
                    <img src="../assets/imgs/register/address.png" alt />
                    <span class="msgTit" style="vertical-align: middle;">办公地址</span>
                    <span class="msgCon" style="vertical-align: middle;">{{companyInfo.workAddr}}</span>
                  </div>
                  <div class="msgItem">
                    <img src="../assets/imgs/register/time.png" alt />
                    <span class="msgTit">工作时间</span>
                    <span class="msgCon">{{companyInfo.workTime}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <button style="cursor: pointer;" class="downBut" @click="goLogin">登录</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timeId;
import protocol from "@/components/protocol";
export default {
  data () {
    return {
      member: true,
      isAgreement: true,
      returnStatus1: false,
      returnStatus2: false,
      returnStatus3: false,
      type: 1, //注册还是更换密码
      step: 1, //进度
      regContent: true,
      area: false,
      register: false,
      inputIndex: 0,
      citylist: [],
      cityId: "",
      cityName: "",
      blNum: "",
      qiyeName: "",
      phone: "",
      time: "",
      cName: "获取验证码",
      password: "",
      rpassword: "",
      code: "",
      differentPass: false,
      zhima: false,
      passwordModes: '',
      companyInfo: '',
      timeTimeout: 3,
      orgName: ''
    };
  },
  components: {
    protocol
  },
  computed: {
    bindModule () {
      const {
        qiyeName,
        blNum,
        cityId
      } = this;
      return {
        qiyeName,
        blNum,
        cityId
      }
    },
    bindModule2 () {
      const {
        phone,
        code,
        password,
        rpassword
      } = this;
      return {
        phone,
        code,
        password,
        rpassword
      }
    },
  },
  created () {
    this.getinfo()
  },
  methods: {
    goLogin: function () {
      this.$router.push({
        path: '/login'
      })
      clearInterval(timeId)
    },
    timeChange: function () {
      timeId = setInterval(() => {
        if (this.timeTimeout > 0) {
          this.timeTimeout--;
        } else {
          this.goLogin()
          clearInterval(timeId)
        }
      }, 1000)
    },
    inputChange (index) {
      this.inputIndex = index;
      if (index == 3) {
        this.area = true;
      }
    },
    goStep (status) {
      if (status == 1) {
        this.step = 1;
        this.$nextTick(() => {
          let input3 = document.getElementById("input3");
          input3.value = this.cityName;
          this.returnStatus1 = false;
          if (this.qiyeName != '' && this.blNum != '' && this.cityId != '') {
            let next = document.querySelector('.next');
            next.style.background = '#2C59C3';
            next.style.cursor = 'pointer'
          } else {
            let next = document.querySelector('.next');
            next.style.backgroundImage = 'linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%)';
            next.style.cursor = 'default';
          }
        })
      }
    },
    select () {
      this.inputIndex = 3;
      this.area = true;
    },
    inputBlur () {
      setTimeout(() => {
        this.area = false;
      }, 300)

    },
    // 获取注册页面信息
    getinfo () {
      let data = {
        modeCode: "TyGGjyoIv5eAWi6XUZf2vE5s2Xiitz0U"
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.citylist = res.data.list;
          }
        })
    },
    // 选择城市
    selectCity (id, name) {
      this.cityId = id;
      this.cityName = name;
      let input3 = document.getElementById("input3");
      input3.value = name;
      this.area = false;
    },
    // 下一步
    tijiao () {
      if (this.qiyeName == "") {
        // this.$Message.warning('请输入企业名字');
        return
      }
      if (this.blNum == "") {
        // this.$Message.warning('请输入组织信用代码');
        return
      }
      // alert(this.cityId)
      if (!this.cityId) {
        // this.$Message.warning('请选择地区');
        return
      }
      // 校验企业是否存在
      let data = {
        modeCode: "NCwXAlrH1dPCj5xjcyHOH9wEpQ42Bs0L",
        blNum: this.blNum,
        orgId: this.cityId,
        enterpriseName: this.qiyeName
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == -1) {
            this.step = 2;
            this.returnStatus1 = true;
          }
          if (res.code == 1) {
            this.companyInfo = res.data.orgExt ? res.data.orgExt : '空';
            this.orgName = res.data.orgName ? res.data.orgName : '空'
            this.register = true;
          }
        })
    },
    // 获取手机验证码
    getCode () {
      /**判断是否是手机号**/
      function isPhoneNumber (tel) {
        var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
        return reg.test(tel);
      }
      if (!isPhoneNumber(this.phone)) {
        this.$Message.warning('请输入正确手机号');
        return;
      }
      if (this.zhima) {
        return;
      }
      this.zhima = true;
      let data = {
        modeCode: "zogmZBEuFbiXbcx0affPtovmmjFvXTfF",
        phone: this.phone,
        type: this.type == 1 ? 'register' : 'forgetPassword'
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.$Message.success('发送成功，请前往手机查看');
            this.cName = "验证码已发送";
            let stime = 60;
            this.time = stime;
            let timeId = setInterval(() => {
              this.time = stime--;
              if (stime <= 0) {
                this.cName = "重新获取";
                this.time = "";
                this.zhima = false;
                clearInterval(timeId);
              }
            }, 1000);
          } else {
            this.cName = "获取验证码";
            this.$Message.warning(res.msg);
            this.zhima = false;
          }
        })
    },
    // 注册
    registerBtn () {
      if (this.phone == "") {
        // this.$Message.warning('请输入手机号');
        return;
      }
      if (this.code == "") {
        // this.$Message.warning('请输入验证码');
        return;
      }
      if (this.password == "") {
        // this.$Message.warning('请输入密码');
        return;
      }
      if (this.rpassword == "") {
        // this.$Message.warning('请输入密码');
        return;
      }
      if (this.password != this.rpassword) {
        this.differentPass = true;
        return;
      }
      if (this.password == this.rpassword) {
        this.differentPass = false;
      }
      if (this.isAgreement) {
        let data = {
          enterpriseName: this.qiyeName,
          blNum: this.blNum,
          orgId: this.cityId,
          phone: this.phone,
          phoneCode: this.code,
          userPwd: this.password,
          pwdLevel: this.passwordModes == 0 ? '1' : this.passwordModes == 4 ? '3' : '2',
          modeCode: "Ykc4JgCx23RNfiEUsTSnJzwnqCqLgtNc"
        }
        this.$http.post(data)
          .then(res => {
            if (res.code == 1) {
              this.step = 3;
              this.returnStatus2 = true;
              this.timeChange();
            } else {
              this.$Message.error(res.msg);
            }
          })
      } else {
        this.$Message.warning('请勾选中资云用户注册协议、会员服务协议！');
      }
    },
    // 判断密码强度
    strength (val) {
      let hh = this.checkStrong(val);
      this.passwordModes = hh;
      let item = document.querySelectorAll(".item");
      if (hh == -1) {
        item[3].classList.remove("active");
      }
      if (hh == 0) {
        item[3].classList.add("active");
      }
      if (hh == 1 || hh == 2 || hh == 3) {
        item[3].classList.add("active");
        item[4].classList.add("active");
      }
      if (hh == 4) {
        item[3].classList.add("active");
        item[4].classList.add("active");
        item[5].classList.add("active");
      }
    },
    checkStrong (val) {
      var modes = 0;

      if (val.length <= 6) return 0;
      if (/\d/.test(val)) modes++; //数字
      if (/[a-z]/.test(val)) modes++; //小写
      if (/[A-Z]/.test(val)) modes++; //大写 
      if (/\W/.test(val)) modes++; //特殊字符
      if (val.length > 12) return 4;
      return modes;
    }
  },
  watch: {
    password: function (newValue, oldValue) {
      function checkStrong (val) {
        var modes = 0;
        if (val.length <= 0) return -1;
        if (val.length <= 6) return 0;
        if (/\d/.test(val)) modes++; //数字
        if (/[a-z]/.test(val)) modes++; //小写
        if (/[A-Z]/.test(val)) modes++; //大写 
        if (/\W/.test(val)) modes++; //特殊字符
        if (val.length > 12) return 4;
        return modes;
      };
      let hh = checkStrong(newValue);
      this.passwordModes = hh;
      let item = document.querySelectorAll(".item");
      if (newValue != oldValue) {
        item[3].classList.remove("active");
        item[4].classList.remove("active");
        item[5].classList.remove("active");
      }
      if (hh == -1) {
        item[3].classList.remove("active");
      }
      if (hh == 0) {
        item[3].classList.add("active");
      }
      if (hh == 1 || hh == 2 || hh == 3) {
        item[3].classList.add("active");
        item[4].classList.add("active");
      }
      if (hh == 4) {
        item[3].classList.add("active");
        item[4].classList.add("active");
        item[5].classList.add("active");
      }
    },
    bindModule: {
      handler: function (newVal) {
        if (newVal.qiyeName != '' && newVal.blNum != '' && newVal.cityId != '') {
          let next = document.querySelector('.nextGo');
          next.style.background = '#2C59C3';
          next.style.cursor = 'pointer'
        } else {
          let next = document.querySelector('.nextGo');
          next.style.backgroundImage = 'linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%)';
          next.style.cursor = 'default';
        }
      }
    },
    bindModule2: {
      handler: function (newVal) {
        if (newVal.phone != '' && newVal.code != '' && newVal.password != '' && newVal.rpassword) {
          let next = document.querySelector('.nextReginster');
          next.style.background = '#2C59C3';
          next.style.cursor = 'pointer'
        } else {
          let next = document.querySelector('.nextReginster');
          next.style.backgroundImage = 'linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%)';
          next.style.cursor = 'default'
        }
      }
    },
    regContent (newVal) {
      if (newVal && newVal == true) {
        this.$nextTick(() => {
          this.strength(this.rpassword);
        })
      }
    }
  }
};
</script>

<style lang="less" scoped>
#register {
  .content {
    text-align: left;
  }

  header {
    height: 34px;
    line-height: 34px;
    background: #f7f9fd;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #616c84;
    letter-spacing: -0.43px;
  }

  .titleBox {
    margin: 30px auto;

    .left {
      display: flex;
      align-items: center;

      span {
        font-family: PingFangSC-Regular;
        font-size: 22px;
        color: #252a37;
        letter-spacing: 0.39px;
        margin: 0 20px;
      }
    }

    .right {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #000000;
      letter-spacing: 0.32px;

      a {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #2c59c3;
        letter-spacing: 0.26px;
        line-height: 25px;
      }
    }
  }

  /* 步骤条 */
  .progress {
    margin: 20px auto;
    border-bottom: 2px solid #d7dce7;
    padding: 0 200px;
    height: 35px;
    line-height: 30px;

    .item {
      width: 210px;
      display: flex;
      align-items: center;
      padding: 5px 12px;
      cursor: pointer;

      span {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #252a37;
        margin-left: 10px;
        letter-spacing: 0.29px;
      }

      /* 步骤序号 */
      .step {
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #b0b5c1;
        color: #fff;
        border-radius: 50%;
        text-align: center;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.29px;
      }
    }

    .line {
      margin: 0 30px;
    }

    /* 进度条激活样式 */
    .item.active {
      border-bottom: 2px solid #2c59c3;
      margin-bottom: -2px;

      .step {
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
      }
    }
    .stepFinish img {
      vertical-align: middle;
    }
  }
  /* 注册 */
  .registerBox {
    background: #ffffff;
    border-radius: 10px;
    width: 660px;
    min-height: 640px;
    margin: 40px auto;
    box-shadow: 0 10px 90px 0 rgba(29, 42, 67, 0.05);

    .title {
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 26px;
      color: #2c59c3;
      letter-spacing: 0.46px;
      padding: 30px 0;
      border-bottom: 1px solid #ebedf3;
    }

    .title p:nth-child(2) {
      font-weight: 600;
    }

    .inputBox {
      width: 368px;
      margin: 30px auto;

      .line {
        margin: 10px 0;
      }

      .line p {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #9097a9;
        letter-spacing: 0.3px;
      }

      input {
        width: 100%;
        height: 48px;
        line-height: 48px;
        border: 0;
        outline: none;
        padding-left: 15px;
        background: #ffffff;
        border: 1px solid #dfdfdf;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        margin: 8px 0;
        font-size: 16px;
      }

      input.active {
        border: 1px solid #2255ce;
      }
    }
  }

  .input {
    position: relative;
  }

  .line .down {
    position: absolute;
    top: 30px;
    right: 10px;
  }

  .registerBox .inputBox .line.relative {
    position: relative;
  }

  /* 下拉框 */
  .line .selectBox {
    background: #ffffff;
    border: 1px solid #dadada;
    box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
    width: 240px;
    height: 270px;
    overflow-y: scroll;
    border-radius: 10px;

    li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #dadada;
      padding-left: 15px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0.26px;
    }

    li:hover {
      background: #fafafa;
      color: #4a4a4a;
    }
  }

  input:hover {
    border: 1px solid red;
  }

  /* 下一步按钮 */
  .next {
    width: 368px;
    height: 48px;
    line-height: 48px;
    margin: 20px auto;
    background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
    border: 1px solid #b2c9ff;
    border-radius: 8px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0.34px;
  }

  /* 进度2 */
  .secondStep .title,
  .thirdStep .title {
    padding: 15px;
    font-weight: 600;
  }

  .secondStep {
    .inputBox {
      margin: 15px auto;
    }

    .code {
      width: 383px;

      input {
        width: 220px;
      }

      .send {
        background-image: linear-gradient(180deg, #fcfcfc 0%, #f5f5f5 100%);
        border: 1px solid #dfdfdf;
        border-radius: 8px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #666666;
        letter-spacing: 0.3px;
        text-align: center;
        width: 130px;
        height: 48px;
        line-height: 48px;
        cursor: pointer;
        position: relative;
        right: 16px;
      }
    }

    /* 密码强度 */
    .strength {
      width: 228px;
      height: 18px;
      background: #ffffff;
      border: 1px solid #dfdfdf;
      box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.17);
      border-radius: 8px;

      .item {
        width: 74px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0.22px;
        background-image: linear-gradient(0deg, #c6cfd6 0%, #f5f6f8 100%);
      }

      .item:first-child {
        border-radius: 8px 0 0 8px;
      }

      .item:last-child {
        border-radius: 0 8px 8px 0;
      }

      /* 强度激活样式 */
      .item.active {
        background-image: linear-gradient(180deg, #fad961 0%, #f76b1c 100%);
      }
    }

    .bottom {
      padding-top: 14px;
      border-top: 1px solid rgba(151, 151, 151, 0.1);
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #9999a8;
      letter-spacing: 0.22px;

      .showAgree {
        color: #2d5ac3;
        cursor: pointer;
      }
    }

    /* 两次密码不一致 */
    .input {
      position: relative;

      .different {
        position: absolute;
        top: 20px;
        right: 0;
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #ffffff;
        background: #dc554f;
        border-radius: 4px;
        letter-spacing: 0.22px;
        height: 26px;
        line-height: 26px;
        padding: 0 15px;
      }
    }
    .butBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .backBut {
        width: 120px;
        border: 1px solid #2255ce;
        border-radius: 8px;
        height: 48px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2255ce;
        letter-spacing: 0.3px;
      }
      .next {
        width: 220px;
        margin: 20px 0;
      }
    }
  }

  /* 进度3 */
  .thirdStep {
    position: relative;
    height: 640px;

    .thirdContent {
      width: 52%;
      margin: 80px auto;
      text-align: center;

      .successMsg {
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #252a37;
        letter-spacing: 0.39px;
        text-align: center;
        margin: 30px 0;

        a {
          color: #2c59c3;
        }
      }
    }

    .bottom {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-top: 1px solid rgba(151, 151, 151, 0.1);
      position: absolute;
      bottom: 0;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #9999a8;
      letter-spacing: 0.22px;
      text-align: center;
    }
  }

  /* 底部 */
  footer {
    width: 100%;
    margin: 40px 0 0;

    .top {
      height: 94px;
      background: #f7f9fd;

      .content {
        padding: 20px 0 0;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #616c84;
        letter-spacing: 0.22px;

        p {
          margin: 10px 0;
        }

        .bottomLogo {
          margin: 0 10px;
        }
      }
    }

    .bottom {
      height: 30px;
      line-height: 30px;
      background: #153684;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0.22px;
      text-align: center;
    }
  }

  /* 协议 */
  .agreement {
    margin: 30px auto;
    min-height: 718px;

    .back {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #adb2bc;
      letter-spacing: 0.26px;
      cursor: pointer;

      img {
        margin: 0 5px;
        vertical-align: middle;
      }
    }

    .agree {
      width: 875px;
      margin: 20px auto;

      .argeeTit {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.3px;
        text-align: center;
        font-weight: 600;
        padding: 20px 0;
        border-bottom: 1px solid #ebedf3;
      }

      .agreeCon {
        margin: 30px auto;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0.25px;
        text-align: justify;
        line-height: 22px;

        .head {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #252a37;
          letter-spacing: 0.25px;
          text-align: justify;
          font-weight: 600;
          margin: 8px 0;
        }

        p {
          margin: 5px 0;
        }
      }
    }
  }

  /* 弹出层 */
  .alert {
    width: 480px;
    height: 390px;
    background: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    margin-top: -185px;
    margin-left: -240px;

    .alertContent {
      .title {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
        text-align: center;
        padding: 15px 0;
        border-bottom: 1px solid #e9e9e9;
      }

      .middle {
        margin: 15px auto;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0;

        .bg {
          background: url("../assets/imgs/register/alertbg.png") no-repeat;
          background-size: 100%;
          width: 408px;
          height: 140px;
          margin: 15px auto;
          text-align: center;
          padding: 10px 20px;

          .bgTitle {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4a4a4a;
            letter-spacing: 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #e9e9e9;
          }

          .msgBox {
            padding: 5px 40px;
            text-align: left;

            .msgItem {
              margin: 5px 0;

              img {
                vertical-align: middle;
                margin: 0 4px;
              }

              .msgTit {
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #9097a9;
                letter-spacing: 0;
                margin: 0 6px;
              }

              .msgCon {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #4a4a4a;
                letter-spacing: 0;
              }
            }
          }
        }
      }
    }

    .bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background: #f5f5f5;
      border-radius: 0 0 10px 10px;
      text-align: center;

      .downBut {
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        width: 138px;
        height: 30px;
        line-height: 30px;

        a {
          color: #fff;
        }
      }
    }
  }
}
</style>
